import React, { Component } from 'react';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
import Config from "../../../../config/config";
import logo from '../../../../images/LOGO_PATHE.png';

export default class BiosInput extends Component {

	constructor(props) {
		super(props);

		this.state = {roomcode: ''};
		this.roomChange = this.roomChange.bind(this);
	}

	componentDidMount() {
		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Login-Bios',
			'page_path': '/login/bios'
		});
	}

	/**
	 * Handle room input change, when length 4 reached, then send it to the API
	 * @param {e} e Key event 
	 */
	roomChange(e) {
		const roomCode = e.target.value;
		this.setState({roomcode: roomCode});
		if (roomCode.length === 4) {
			this.props.roomChangeHandler(roomCode)
		}
	}

	render() {
		return(
			<div className="enterbioscode">
				<div className="logo" ><img src={logo} width="100%" alt="logo" /></div>
				VUL DE VIERCIJFERIGE<br/>
				<span className="large">GAMECODE</span><br/>
				IN OM MEE TO SPELEN<br/>
				<input className="roominput" type="tel" size="4" maxLength="4" value={this.state.roomcode} onChange={this.roomChange} autoFocus />
				{/* We don't include the popcorn logo on this page as it interferes with the numeric text input /*}
				{/* <div className="popcorn"><img style={{width:"100%"}} src={popcorn} alt="popcorn" /></div> */}
			{/* <div className="curtains" ></div> */}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/pages/Login/BiosInput/BiosInput.js